import type { OfferChangeRequest, OfferItem } from '../types';

function requestTime(r: OfferChangeRequest): number | null {
  const ms = r.createdAt ? Date.parse(r.createdAt) : NaN;
  return Number.isFinite(ms) ? ms : null;
}

/** Newest change request, independent of the order the API returns them in. */
export function latestChangeRequest(
  requests?: OfferChangeRequest[] | null,
): OfferChangeRequest | undefined {
  if (!requests || requests.length === 0) return undefined;
  return requests.reduce((latest, r) => {
    const a = requestTime(r);
    const b = requestTime(latest);
    if (a != null && b != null && a !== b) return a > b ? r : latest;
    if (a != null && b == null) return r;
    if (a == null && b != null) return latest;
    return r.id > latest.id ? r : latest;
  });
}

/** Price the candidate proposed in their most recent change request, if any. */
export function parseProposedPrice(offer?: Pick<OfferItem, 'changeRequests'>): number | null {
  const terms = latestChangeRequest(offer?.changeRequests)?.proposedTerms;
  if (!terms) return null;
  const match = terms.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
  if (!match) return null;
  const amount = Number(match[1]);
  return Number.isFinite(amount) && amount > 0 ? amount : null;
}
